import { getYear } from "date-fns";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import filterUnionByTypename from "lib/utils/filterUnionByTypename";
import parseDateYmd from "lib/utils/parseDateYmd";
import { last } from "lodash";

export default function hasOneCompensation(
  totalCompensations: IBrazilianCompanyIssuerTopLevelFragment["totalCompensations"],
  financials: IBrazilianCompanyIssuerTopLevelFragment["financials"],
) {
  const { yearly } = financials;

  const yearlyBankFinancials = filterUnionByTypename(yearly, "YearlyBrazilianBankFinancialStatementRow");
  const yearlyCompanyFinancials = filterUnionByTypename(yearly, "YearlyBrazilianCompanyFinancialStatementRow");
  const yearlyInsurerFinancials = filterUnionByTypename(yearly, "YearlyBrazilianInsurerFinancialStatementRow");

  const isBank = yearlyBankFinancials.length > 0;
  const isCompany = yearlyCompanyFinancials.length > 0;
  const isInsurer = yearlyInsurerFinancials.length > 0;

  const topCompensation = last(
    totalCompensations.filter((compensation) => {
      const compensationFiscalYearEnd = getYear(parseDateYmd(compensation.fiscalYearEnd));
      if (isBank) {
        return yearlyBankFinancials.some(
          ({ endOfPeriod }) => getYear(parseDateYmd(endOfPeriod)) === compensationFiscalYearEnd,
        );
      }
      if (isCompany) {
        return yearlyCompanyFinancials.some(
          ({ endOfPeriod }) => getYear(parseDateYmd(endOfPeriod)) === compensationFiscalYearEnd,
        );
      }
      if (isInsurer) {
        return yearlyInsurerFinancials.some(
          ({ endOfPeriod }) => getYear(parseDateYmd(endOfPeriod)) === compensationFiscalYearEnd,
        );
      }

      return false;
    }),
  );

  return !!topCompensation;
}
